import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    columnGap: 12,
    gridTemplateColumns: '1fr 2fr',
    marginBottom: 20,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
      gridTemplateColumns: '1fr',
      columnGap: 0,
      rowGap: 8
    }
  },
  rootForTenantRole: {
    gridTemplateColumns: '1fr'
  },
  roleSelectorContainer: {
    width: '25%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 12
    }
  },
  searchInput: {
    marginBottom: 12
  },
  clearIconButton: {
    position: 'absolute',
    top: '5%',
    right: 32,
    cursor: 'pointer'
  },
  clearIcon: {
    fontSize: 16
  },
  entitySelectorContainer: {
    width: '46%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 12
    }
  },
  resourceTypeSelectorContainer: {
    width: '25%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}))

export default useStyles
